import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationSafetyService } from './services/navigation-safety';
import { IframeResizeService } from './services/iframe-resize.service';
import { FeatureFlagService } from './services/feature-flags';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.html',
  imports: [RouterOutlet],
})
export class App {
  private navSafety = inject(NavigationSafetyService);
  private autoResize = inject(IframeResizeService);
  private featureFlagService = inject(FeatureFlagService);

  constructor() {
    this.navSafety.init();
    this.autoResize.init();
    this.featureFlagService.start();
  }
}
